import { headerLogoCenterAlt } from './HeaderLogoStore.js';

export const updateHeaderLogoCenterAlt = (value) => headerLogoCenterAlt.update((oldValue) => value);
